import "./card-container.styles.scss";

const CardContainer = ({ children }) => {
  return <div className="card-container tcs-container">{children}</div>;
};

export default CardContainer;
